export default __webpack_public_path__ + "8d7a32f151ec9d0ca4b73943cafb563f.svg";